import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSquareRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 32 32",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M24 7.2q.7.1.8.8v16q-.1.7-.8.8H8a1 1 0 0 1-.8-.8V8q.1-.7.8-.8zM8 4.8A3 3 0 0 0 4.8 8v16c0 1.8 1.4 3.2 3.2 3.2h16c1.8 0 3.2-1.4 3.2-3.2V8c0-1.8-1.4-3.2-3.2-3.2z" })
});
export default SvgSquareRegularIcon;
